import { render, staticRenderFns } from "./TraxNotificationWidget.vue?vue&type=template&id=3023c606"
import script from "./TraxNotificationWidget.vue?vue&type=script&lang=js"
export * from "./TraxNotificationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports